import React, { useState, memo } from 'react';
import Header from './components/Header';
import TabNavigation from './components/TabNavigation';
import Overview from './components/Overview';
import PipelineDetail from './components/PipelineDetail';
import DataTable from './components/DataTable';
import { mockData } from './utils/mockData';
import { DateRange } from './types';
export function App() {
  const [activeTab, setActiveTab] = useState('overview');
  const [dateRange, setDateRange] = useState<DateRange>({
    type: 'month',
    startDate: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
    endDate: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)
  });
  const handleTabChange = (tab: string) => {
    setActiveTab(tab);
  };
  const handleDateRangeChange = (newDateRange: DateRange) => {
    setDateRange(newDateRange);
  };
  const renderContent = () => {
    switch (activeTab) {
      case 'overview':
        return <Overview data={mockData} dateRange={dateRange} data-id="element-0" />;
      case 'forms':
        return <PipelineDetail pipelineType="form" data={mockData} dateRange={dateRange} data-id="element-1" />;
      case 'letters':
        return <PipelineDetail pipelineType="letter" data={mockData} dateRange={dateRange} data-id="element-2" />;
      case 'memos':
        return <PipelineDetail pipelineType="memo" data={mockData} dateRange={dateRange} data-id="element-3" />;
      default:
        return <Overview data={mockData} dateRange={dateRange} data-id="element-4" />;
    }
  };
  return <div className="min-h-screen bg-background" data-id="element-5">
      <Header dateRange={dateRange} onDateRangeChange={handleDateRangeChange} data-id="element-6" />
      <main className="container py-6" data-id="element-7">
        <TabNavigation activeTab={activeTab} onTabChange={handleTabChange} data-id="element-8" />
        <div className="mt-6" data-id="element-9">{renderContent()}</div>
      </main>
    </div>;
}